import React, { useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { audioActions } from "store/audioSlice";

const Audio = ({ onTimeUpdate, onLoadedMetadata, setPosition }) => {
  const audioRef = useRef(null);
  const { url, isPlaying, shouldReset } = useSelector((state) => state.audio);
  const dispatch = useDispatch();

  useEffect(() => {
    if (shouldReset && audioRef.current) {
      audioRef.current.currentTime = 0;
      setPosition(0);
      dispatch(audioActions.clearResetFlag());
    }
  }, [shouldReset, dispatch]);

  useEffect(() => {
    const audio = audioRef.current;

    const loadAndPlay = async () => {
      try {
        // Reset any previous audio state
        audio.pause();
        audio.currentTime = 0;
        audio.src = url;

        // Attempt to load the new audio
        await audio.load();

        // Attempt to play if isPlaying is true
        if (isPlaying) {
          await audio.play();
          // const playPromise = audio.play();
          // if (playPromise !== undefined) {
          //   playPromise
          //     .then(() => {
          //       // Playback started successfully
          //     })
          //     .catch((error) => {
          //       console.error("Failed to play:", error);
          //       dispatch(audioActions.pause());
          //     });
          // }
        }
      } catch (error) {
        console.error("Error during load and play:", error);
      }
    };

    // Load and play the audio
    loadAndPlay();

    // Cleanup: Pause the audio when the component unmounts or url changes
    return () => {
      audio.pause();
    };
  }, [url, dispatch]);

  useEffect(() => {
    // Control playing state
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.play().catch((err) => {
          console.error("Failed to play:", err);
          dispatch(audioActions.pause());
        });
      } else {
        audioRef.current.pause();
      }
    }
  }, [isPlaying, dispatch]);

  return (
    <audio
      ref={audioRef}
      src={url}
      onTimeUpdate={onTimeUpdate}
      onLoadedMetadata={onLoadedMetadata}
      //onEnded={() => dispatch(audioActions.pause())}
    />
  );
};

export default Audio;
